import { appsignal } from "#shared/utils/appsignal"
import { errorHandler } from "@appsignal/vue"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = errorHandler(appsignal, nuxtApp.vueApp)
})
